import DriverSettlementList from "../../components/accounting/DriverSettlementList";

export default function Settlements() {
  return <DriverSettlementList />;
}
